import moment from 'moment-timezone';

/** Keep in sync with backend/utils/parseDateInMiamiTZ.js */
export const MIAMI_TZ = 'America/New_York';
const MIAMI_DATE_FORMATS = ['MM/DD/YYYY', 'M/D/YYYY', 'YYYY-MM-DD'];

/**
 * Parse a date to Miami start-of-day, matching backend parseDateInMiamiTZ.
 * Date-only / MM/DD/YYYY strings are interpreted in America/New_York (not UTC).
 */
export const parseDateInMiamiTZ = value => {
  if (value == null || value === '') return null;

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    const parsed = moment(value).tz(MIAMI_TZ);
    return parsed.isValid() ? parsed.startOf('day').toDate() : null;
  }

  const text = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}T/.test(text)) {
    const parsed = moment(text).tz(MIAMI_TZ);
    return parsed.isValid() ? parsed.startOf('day').toDate() : null;
  }

  const parsed = moment.tz(text, MIAMI_DATE_FORMATS, MIAMI_TZ);
  if (!parsed.isValid()) return null;

  return parsed.startOf('day').toDate();
};
